module.exports = __webpack_public_path__ + "img/quanyi.d30b44e8.png";